import { ReactNode, useMemo } from "react";
import { ConnectComponentsProvider } from "@stripe/react-connect-js";
import { CustomFontSource, loadConnectAndInitialize } from "@stripe/connect-js";
import { Api, unknown } from "./Data/Api";
import { useParamIds } from "./Data/Common";
import { loadResult } from "./Data/Result";

const silkaRegular: CustomFontSource = {
    family: "silka",
    src: "local('silka'), url(/fonts/silka-regular-webfont.woff) format('woff')",
    weight: "normal",
};

const silkaBold: CustomFontSource = {
    family: "silka",
    src: "local('silka'), url(/fonts/silka-bold-webfont.woff) format('woff')",
    weight: "bold",
};

export function StripeConnectBoundary( { children }: { children: ReactNode } ) {
    const { facilityId } = useParamIds() as { facilityId: number };

    const connectInstance = useMemo( () => {
        const fetchClientSecret = async () => {
            return loadResult( await Api.stripeInit( facilityId ),
                val => val.clientSecret,
                err => "Err!" );
        };

        return loadConnectAndInitialize( {
            publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY!,
            fetchClientSecret: fetchClientSecret,
            appearance: {
                variables: {
                    fontFamily:                     "silka",
                    bodyMdFontWeight:               "400",
                    bodySmFontWeight:               "400",
                    labelMdFontWeight:              "300",
                    labelSmFontWeight:              "300",
                    fontSizeBase:                   "16px",
                    spacingUnit:                    "9px",
                    buttonBorderRadius:             "16px",
                    colorPrimary:                   "#D61F84",
                    buttonPrimaryColorText:         "#000000",
                    buttonPrimaryColorBackground:   "#FFFFFF",
                    buttonPrimaryColorBorder:       "#D61F84",
                    buttonSecondaryColorBackground: "#FFFFFF",
                    buttonSecondaryColorBorder:     "#D61F84",
                    buttonSecondaryColorText:       "#000000",
                },
            },
            fonts: [silkaRegular, silkaBold],
        } );
    }, [facilityId] );

    return (
        <ConnectComponentsProvider connectInstance={connectInstance}>
            {children}
        </ConnectComponentsProvider>
    );
}
